import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CourseSlide } from 'src/app/shared/models/course';
import { Message } from 'src/app/shared/models/domain';
import { CommonService } from 'src/app/shared/services/common.service';
import { CourseService } from 'src/app/shared/services/course.service';

@Component({
  selector: 'app-view-slide-popup',
  templateUrl: './view-slide-popup.component.html',
  styleUrls: ['./view-slide-popup.component.scss']
})
export class ViewSlidePopupComponent implements OnInit {

  @Output() emitResponse = new EventEmitter<any>();
  @ViewChild('fileInput') fileInput!: ElementRef;
  @Input() slide: CourseSlide;
  public selectedFileName: string = '';
  public fileName: string | null = null;
  public isLoading: boolean = false;
  constructor(public activeModal: NgbActiveModal,
    private courseService: CourseService,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
  }

  public selectAndUpsertImage(): void {
    this.fileInput.nativeElement.click();
  }

  public uploadImage(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.selectedFileName = file.name;
      const slideImage = new FormData();
      slideImage.append('file', file);
      this.isLoading = true;
      this.courseService.upsertCourseSlideImage(this.slide?.id, slideImage).subscribe({
        next: (response: Message) => {
          this.isLoading = false;
          if (!response.failed) {
            this.slide.mediaUrl = response.payload;
            this.emitResponse.emit(this.slide);
            this.commonService.setToastr(200, response.text);
            this.activeModal.close(false);
          } else {
            this.commonService.setToastr(response.code || 500, response.text);
          }
        },
        error: () => {
          this.isLoading = false;
          this.commonService.setToastr(500, "Image upload failed! Please try again.");
        }
      });
    }
  }
}  
